function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "ic_present_to_all_24px",
  fill: "#fff",
  d: "M19.182 3H2.818A1.812 1.812 0 0 0 1 4.818v12.727a1.812 1.812 0 0 0 1.818 1.818h16.364A1.812 1.812 0 0 0 21 17.545V4.818A1.812 1.812 0 0 0 19.182 3zm0 14.564H2.818V4.8h16.364zm-10-6.382H7.364L11 7.545l3.636 3.636h-1.818v3.636H9.182z",
  opacity: 0.5
});
var SvgNavbarEproxy = function SvgNavbarEproxy(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Btn_NetBar_eProxy",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavbarEproxy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/navbar_eproxy.2c197fb3.svg";
export { ForwardRef as ReactComponent };